import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'app/_services/common.service'


@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {

  public veteran_status;
  public senior_status;
  public userIdWithhoutSignup;
  public feedbackResp;
  public yFeedback;
  public nFeedback;
  public currentUser;
  public userSignup;
  

  feedbackForm = this
  .formBuilder
  .group({
    feedbackStatus: [
      '', Validators.required
    ],
  });

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService : CommonService,

  ) { }

  ngOnInit(): void {

    this.veteran_status =  JSON.parse(localStorage.getItem('veteran_status'));
    this.senior_status =  JSON.parse(localStorage.getItem('senior_status'));
    this.userIdWithhoutSignup = localStorage.getItem('userIdWithhoutSignup')

    if(this.veteran_status === 0 || this.senior_status === 0){
      this.showFeedback();
    }
  }

  showFeedback(){
    if(this.feedbackForm.value.feedbackStatus === 1){
      this.yFeedback = "true"
      this.router.navigate(['/food-service'])
    } else if (this.feedbackForm.value.feedbackStatus === 0){
      this.nFeedback = "true"
      this.saveFeedback();
    }
    else{
      this.yFeedback = "false",
      this.nFeedback = "false"
    }
  }


  saveFeedback(){
    let userId ;
    this.currentUser =  JSON.parse(localStorage.getItem('currentUser'));
    this.userIdWithhoutSignup = localStorage.getItem('userIdWithhoutSignup');
    this.userSignup = localStorage.getItem('user_id');

    if(this.currentUser != null && this.currentUser != undefined){
       userId = this.currentUser.data.user_id
    }
    else if (this.userIdWithhoutSignup != null && this.userIdWithhoutSignup !=undefined){
      userId = this.userIdWithhoutSignup
    }
    else if (this.userSignup != null && this.userSignup != undefined){
      userId = this.userSignup
    }
    else {
      userId = null;
    }

    if(userId != null && userId != undefined){
      let input : {}
      input = {
        user_id : userId
      }
      this.commonService.updateFeedback(input).subscribe(res => {
      this.feedbackResp =  res.body
        if(this.feedbackResp.status == "200"){
          let tax = localStorage.getItem('tax');
          if(tax == "true"){
            this.router.navigate(['/tax-assistamce'])
          }
          else{
            this.router.navigate(['/food-service'])

          }
        } else{
          console.log("feedback resp error")
        }
      }, err => console.error('Cannot Fetch users history List' + err))

    } else {
      this.router.navigate(['/login'])
    }
    console.log("feedbacformsave", this.feedbackForm.value.feedbackStatus);
  }


  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn === "true") {
      this.router.navigate(['/user-history'])
    } else {
      alert("No History Found, Please login");
      this.router.navigate(['/login'])

    }
  }

  navigateMenu(){
    this.router.navigate(['/search1-screen']);
    console.log("navigateMenu")
  }
  
}
